var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalEmployeeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#145DFD",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1438 25.6002C24.3709 25.6002 24.5887 25.51 24.7492 25.3494C24.9098 25.1888 25 24.971 25 24.7439V23.6771C25.0034 21.2744 21.5973 19.3924 18.1501 19.3924C14.7029 19.3924 11.3002 21.2744 11.3002 23.6771V24.7439C11.3002 24.971 11.3904 25.1888 11.551 25.3494C11.7115 25.51 11.9293 25.6002 12.1564 25.6002H24.1438ZM21.236 13.7019C21.236 14.1071 21.1562 14.5084 21.0011 14.8828C20.846 15.2572 20.6187 15.5974 20.3322 15.8839C20.0456 16.1705 19.7054 16.3978 19.331 16.5528C18.9566 16.7079 18.5553 16.7877 18.1501 16.7877C17.7449 16.7877 17.3436 16.7079 16.9692 16.5528C16.5948 16.3978 16.2546 16.1705 15.968 15.8839C15.6815 15.5974 15.4542 15.2572 15.2991 14.8828C15.144 14.5084 15.0642 14.1071 15.0642 13.7019C15.0642 12.8834 15.3893 12.0985 15.968 11.5198C16.5468 10.9411 17.3317 10.616 18.1501 10.616C18.9685 10.616 19.7534 10.9411 20.3322 11.5198C20.9109 12.0985 21.236 12.8834 21.236 13.7019Z",
    stroke: "#145DFD",
    strokeWidth: 1.28436,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalEmployeeIcon);
export default __webpack_public_path__ + "static/media/TotalEmployeeIcon.b2d78676c07fc1cde1acaf0616d320bc.svg";
export { ForwardRef as ReactComponent };